import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaMoon, FaSun } from 'react-icons/fa';

export default function Summary() {
  const location = useLocation();
  const navigate = useNavigate();
  const formData = location.state?.formData || {};
  const [dark, setDark] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const genderText = ['مرد', 'زن'][formData.Gender] || '';
  const goalText = ['کاهش وزن', 'عضله‌سازی', 'تناسب اندام', 'افزایش قدرت', 'افزایش استقامت', 'بازتوانی'][formData.Goal] || '';
  const planTypeText = ['رایگان', 'عادی', 'پرمیوم'][formData.PlanType] || '';
  const requestedPlanText = ['-', 'فقط تمرین', 'فقط تغذیه', 'هر دو'][formData.RequestedPlan] || '';
  const equipmentText = ['فقط وزن بدن', 'وزن بدن + دمبل', 'وزن بدن و کش سی ایکس تراباند','باشگاه کامل'][formData.EquipmentAccess] || '';
const API_URL = process.env.REACT_APP_API_URL;

  const handleSubmit = async () => {
    setLoading(true);
    setError('');

    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`https://api.mogym.ir/api/plan/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(formData)
      });

      const result = await res.json();
      const price = Number(result.Price); // تبدیل به عدد

      if (res.status === 200 && result.PlanId &&  !isNaN(price)) {
        console.log('test');
        localStorage.setItem('planId', result.PlanId);
        localStorage.setItem('price', result.Price);
        localStorage.setItem('planTitle', result.PlanTitle || 'برنامه انتخابی');

        navigate('/payment');
      } else {
        setError(result.Message);
      }
    } catch (err) {
      setError('ارتباط با سرور ممکن نیست.');
    }

    setLoading(false);
  };

  return (
    <div className={dark ? 'dark' : ''}>
      <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-[#0e1015] text-black dark:text-white px-4 font-vazir relative">
        <div className="bg-white dark:bg-[#1a1d2e] p-6 rounded-xl shadow max-w-md w-full relative z-10">
          <h1 className="text-xl font-bold mb-6 text-center">خلاصه اطلاعات برنامه</h1>

          {/* نمایش برخی اطلاعات formData برای تأیید کاربر */}
      <div className="bg-gray-100 dark:bg-[#1c1f2b] rounded-xl p-6 space-y-3">
        <p><strong>نوع پلن:</strong> {planTypeText}</p>
        <p><strong>برنامه درخواستی:</strong> {requestedPlanText}</p>
        <p><strong>سن:</strong> {formData.Age}</p>
        <p><strong>قد:</strong> {formData.Height} سانتی‌متر</p>
        <p><strong>وزن:</strong> {formData.Weight} کیلوگرم</p>
        <p><strong>جنسیت:</strong> {genderText}</p>
        <p><strong>هدف:</strong> {goalText}</p>
        <p><strong>تعداد روز تمرین:</strong> {formData.TrainingDaysPerWeek}</p>
        <p><strong>تجهیزات:</strong> {equipmentText}</p>
        <p><strong>مبلغ قابل پرداخت:</strong> <span className="text-green-600 font-bold">{formData.Price?.toLocaleString()} تومان</span></p>
      </div>

          {error && <p className="text-red-500 text-sm mb-4 text-center">{error}</p>}

          <button
            onClick={handleSubmit}
            disabled={loading}
            className="bg-blue-600 hover:bg-blue-700 text-white w-full py-3 rounded-xl disabled:opacity-50"
          >
            {loading ? 'در حال ارسال اطلاعات...' : 'ادامه به پرداخت'}
          </button>
        </div>

        {/* دکمه تغییر تم */}
        <button
          onClick={() => setDark(!dark)}
          className="fixed top-4 right-4 z-50 px-3 py-2 bg-gray-700 text-white rounded-full shadow-lg"
        >
          {dark ? <FaSun className="text-yellow-400" /> : <FaMoon className="text-blue-500" />}
        </button>
      </div>
    </div>
  );
}
